/* eslint-disable no-multi-str */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React from 'react';

import jwt, { SignOptions } from 'jsonwebtoken';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import jwtDecode, { JwtPayload } from 'jwt-decode';
import { useDispatch } from 'react-redux';
import ProductLayout from '~/pages/_layouts/ProductLayout';
import DefaultLayout from '~/pages/_layouts/DefaultLayout';
import BlankLayout from '~/pages/_layouts/BlankLayout';
import { AuthService } from '~/store/ducks/Auth/services';
import { resetRoom } from '~/store/ducks/Room/actions';
import { login } from '~/store/ducks/Auth/actions';

type RouteWrapperProps = {
  component: React.ElementType;
  pageTitle?: string;
  isPrivate?: boolean;
  isLogin?: boolean;
  isRefreshState?: boolean;
} & RouteProps;

export function RouteWrapper({
  component: Component,
  isPrivate,
  isLogin,
  isRefreshState,
  pageTitle,
  ...rest
}: RouteWrapperProps) {
  const signJwt = (payload: Object, options: SignOptions) => {
    // privateKey in base64 encode
    const keyName =
      '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';
    const privateKey = Buffer.from(keyName, 'base64').toString('ascii');
    // const keyName =
    //   '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';
    // const privateKey = keyName;
    const token = jwt.sign(payload, privateKey, {
      ...(options && options),
      algorithm: 'RS256',
    });
    // console.log(token);
    return token;
  };

  const queryParams: any = new URLSearchParams(useLocation().search);
  // Assume authentication from app ElginPro
  if (queryParams.get('token') != null) {
    const _token: any = jwtDecode<JwtPayload>(queryParams.get('token'));
    const _username = _token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    const _iss = _token.iss;
    const _jti = _token.jti;
    const _exp = _token.exp;
    const dispatch = useDispatch();
    try {
      const secret = 'secret';
      const data = {
        username: `coldstorage_${_username}`,
        exp: (Date.now() + 720000) / 1000,
        iss: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_w1acp8V3z',
        jti: _jti,
        token_use: 'access',
        scope: 'openid email',
        sub: '3c289655-3982-42b1-9780-eef5720a79e8',
        'cognito:groups': ['us-east-1_w1acp8V3z_COLDSTORAGE'],
        version: '2',
        client_id: '44g9thh55u6id6ciho8uluui41',
        origin_jti: '0fb9a4b2-91db-4028-a60c-e6c69ab85816',
        auth_time: Date.now() / 1000,
      };
      const jwt_access_token = signJwt(data, null);
      const jwt_refresh_token = signJwt(data, null);
      // console.log({ jwt_access_token, jwt_refresh_token });

      const token = {
        data: {
          access_token: jwt_access_token,
          expires_in: 14400,
          id_token: jwt_access_token,
          refresh_token: jwt_refresh_token,
          token_type: 'Bearer',
        },
      };
      dispatch(login(null, token));
      // console.log(jwt);
    } catch (err) {
      // console.error(err);
    }
  }

  const isAuthenticated: boolean = AuthService.isAuthenticated();

  if (!isAuthenticated && isPrivate) {
    return <Redirect to={{ pathname: '/login', state: { isLogin: true } }} />;
  }

  let Layout = null;
  if (isPrivate) {
    Layout = pageTitle?.startsWith('Compressor ') ? ProductLayout : DefaultLayout;
  } else {
    Layout = BlankLayout;
  }
  const dispatch = useDispatch();

  const refreshState = () => {
    // Refreshing room checklist state before render
    dispatch(resetRoom());
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isRefreshState) {
          refreshState();
        }
        return (
          <Layout>
            <Component {...props} {...rest} />
          </Layout>
        );
      }}
    />
  );
}
